<template>
	<div style="overflow: hidden">
		<div class="grid-content bg-purple">
			<h2 style="float: left;">考核评分</h2>
			<!--<el-tag
        v-for="item in items"
        :key="item.id"
        :type="item.type"
        @click="selectScoreItem(item.id)"
        :class="{active : item.id===curId}"
        effect="light">
        {{ item.label }}
      </el-tag>-->

			<div class="lu_head" style="float: left;">
				<span v-for="item in items" class="lu_list" :class="{lu_active : item.operatorNum===curId}" @click="selectGradeByOperatorNums(item.operatorNum)">
  <img :src="item.logo"/>{{ item.operatorName }}</span>
			</div>

			<div class="clear"></div>
		</div>

		<el-row :gutter="24">
			<el-col :span="18">
				<div class="grid-ent bg-purple">
					<div class="avatar">
						<el-avatar :size="104" :src="userlogo"></el-avatar>
					</div>
					<div class="approval">

						<div class="point">

							<el-col :span="4" style="padding: 0; margin-right: 10px;width:auto;  ">

								<el-date-picker v-model="ayears" style="display: block" type="year" format="yyyy" value-format="yyyy" @change="pickerChangeFn" :picker-options="pickerOptions" placeholder="请选择年份">
								</el-date-picker>
							</el-col>
							<el-col :span="4" style="padding: 0; margin-right: 10px;width:auto; ">

								<el-select v-model="aquarter" placeholder="请选择季度" :clearable="true" style=" padding: 0px 0px 0px;width: 120px;display: block;">

									<el-option v-for="item in quarters" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
                <el-col :span="4 " style="padding: 0; margin-right: 10px; width:auto;">
                  <el-button type="primary" style="width: 139px; height: auto; color: #fff ; text-align: center;" @click="selectGradeByOperatorNums(curId)">查询</el-button>
							</el-col>
						</div>
						<div class="total">
							<h2>当前总评分：</h2>
							<span>{{total_points?total_points:"未评分"}}</span>
							<h2>当前评分评级：</h2>
							<span>{{grade==''?"未评级":grade}}</span>
						</div>
					</div>
					<div class="button"></div>
				</div>
				<div class="grid-main bg-purple">
					<div class="table-box">
						<h2>请按照评分细则与考核资料审核分数并在评分细则下面确认打分</h2>

						<el-table :data="selectScoreItemlist" border style="width: 100%;">

							<el-table-column width="60" type="index" label="序号">
							</el-table-column>
							<el-table-column width="100" prop="scoreTypeName" label="指标类别">
							</el-table-column>
							<el-table-column width="100" label="指标项与分值">
								<template slot-scope="scope">
									{{scope.row.scoreItem}}(分值：{{scope.row.scoreValue}}分)
								</template>
							</el-table-column>
							<el-table-column width="180" label="考核资料">
								<template slot-scope="scope">

									<div v-for="items in scope.row.fileJson">
										<el-link type="primary" :href="items.url" target="_blank">{{items.fileName}}</el-link>
										<br/>
									</div>
								</template>
							</el-table-column>

							<el-table-column label="分值及计算方式">
								<template slot-scope="scope">
									<el-input v-model="scope.row.description" type="textarea" resize="none" :rows="5" disabled placeholder="请输入分值及计算方式："></el-input>

								</template>
							</el-table-column>
							<el-table-column fixed="right" width="150" label="打分">
								<template slot-scope="scope"><!-- :disabled="scope.row.itemScore"-->
									<el-input v-model="scope.row.itemScore" type="number" placeholder="打分" min='0' max="10" oninput="if(value.length > 4) value=value.slice(0, 4)" @change="onChange()" @mousewheel.native.prevent />
								</template>
							</el-table-column>
						</el-table>

					</div>
					<div class="bottom" id="firstAnchor" style="padding-top: 10px;">
						<el-button type="primary" @click="onInputChange()">保存评分</el-button>
					</div>

				</div>
			</el-col>
			<el-col :span="6">
				<div class="grid-cont bg-purple" style="cursor:pointer;" @click="dialogTableVisible = true">
					<div class="aimg"><img src="../../assets/images/01.png"></div>
					<div class="atitle">
						<h3>新建工单</h3>
						<span>线下考核</span>
					</div>
				</div>
				<div class="grid-cont bg-purple" style="cursor:pointer;" @click="selectWorkOrder()">
					<div class="aimg"><img src="../../assets/images/02.png"></div>
					<div class="atitle">
						<h3>我的工单</h3>
						<span>线下考核</span>
					</div>
				</div>
				<!-- <div class="grid-cont bg-purple" style="cursor:pointer;" @click="questi()">
              <div class="aimg"><img src="../../assets/images/03.png"></div>
              <div class="atitle">
                  <h3>新建问卷</h3>
                  <span>线下考核</span>
              </div>
          </div> -->
				<!-- <div class="grid-cont bg-purple" style="cursor:pointer;" @click="questi()">
					<div class="aimg"><img src="../../assets/images/04.png"></div>
					<div class="atitle">
						<h3>我的问卷</h3>
						<span>线下考核</span>
					</div>
				</div> -->

			</el-col>
		</el-row>

		<el-dialog class="table-box" style="background: none;  " :modal="true" :visible.sync="dialogTableVisible">
			<el-form ref="form" label-width="150px">
				<el-form-item label="考核内容：">
					<el-input v-model="workOrder.checkContent" type="text" placeholder="请输入考核内容"></el-input>
				</el-form-item>
				<el-form-item label="考核人数：">
					<el-input v-model="workOrder.checkPopulation" type="number" placeholder="请输入考核人数"></el-input>
				</el-form-item>
				<el-form-item label="考核地址：">
					<el-input v-model="workOrder.address" type="text" placeholder="请输入考核地址"></el-input>
				</el-form-item>
				<el-form-item label="考核点位数：">
					<el-input v-model="workOrder.pointNum" type="number" placeholder="请输入考核考核点位数"></el-input>
				</el-form-item>
				<el-form-item label="考核监督员：">
					<el-input v-model="workOrder.supervisor" type="text" placeholder="请输入考核监督员"></el-input>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" @click="workOrderAdd">确认提交</el-button>

				</el-form-item>
			</el-form>

		</el-dialog>

		<el-dialog class="table-box" style="background: none; padding: 49px 20px;" :visible.sync="dialogworkVisible">
			<el-table :data="workOrlist" border style="width: 100%;
          height:280px">
				<el-table-column prop="checkContent" label="考核内容">
				</el-table-column>
				<el-table-column prop="checkPopulation" label="考核人数">
				</el-table-column>
				<el-table-column prop="address" label="考核地址">

				</el-table-column>
				<el-table-column prop="pointNum" label="考核点位数">

				</el-table-column>

				<el-table-column prop="supervisor" label="考核监督员">

				</el-table-column>

			</el-table>
			<el-pagination background layout="prev, pager, next" :page-size="workOrderpageSize" @current-change="setselWorkOrder" :total="workOrdertotal">

			</el-pagination>

		</el-dialog>

	</div>

</template>

<script>
	import { api_duck } from '../../assets/js/commt';
	export default {
		name: "Grade",
		data() {
			return {
				quarters: [{
						id: 1,
						name: '第一季度',

					},
					{
						id: 2,
						name: '第二季度',

					},
					{
						id: 3,
						name: '第三季度',
					},
					{
						id: 4,
						name: '第四季度',
					},
				],
				items: [{
						id: 1,
						type: 'success',
						code: 'MT'
					},
					{
						id: 2,
						type: 'info',
						code: 'HB'
					},
					{
						id: 3,
						type: 'danger',
						code: 'DD'
					},
				],
				curId: 1,
				gradelist: ['A', 'B', 'C', 'D'],
				userlogo: '',
				totalPoints: 0,
				grade: '',
				selectScoreItemlist: [],

				dialogTableVisible: false,

				workOrder: {},
				WorkOrderpage: 1,
				workOrdertotal: 0,
				workOrderpageSize: 10,
				workOrlist: [],
				dialogworkVisible: false,
				year: [],
				quarter: [],
				ayears: '',
				aquarter: '',
				ayear: '',
				aquarte: '',
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() > Date.now();
					},
				},
				total_points: 0
			}
		},
		props: ['userphone'],
		watch: {
			userphone: function(value) {
				console.log(value)
			},
		},
		beforeRouteEnter(to, from, next) {

			next((vm) => {

			});
		},
		created() {

		},
		mounted() {
//			this.selectScoreItem(1);
			// this.examinePeriodSelectAll();
			this.selectAllOperator()
			this.selectGradeByOperatorNums(this.curId)
		},
		methods: {
			//获取所有企业
			selectAllOperator() {
				let that = this;
				this.$axios
					.get('/api/operator/selectAllOperator')
					.then(function(res) {
						if(res.data.code == 200) {
							that.items = res.data.data;
							that.curId = res.data.data[0].operatorNum
						}

					})
			},
			pickerChangeFn(value) { // 日期选择器改变事件 ~ 解决日期选择器清空 值不清空的问题
				if(value === null) {
					this.ayears = value

					console.log(this.ayears)
				}
			},

			//详情页总分
			selectGradeByOperatorNums(peratorNum) {
				var that = this;
				this.curId = peratorNum;
				var OperatorNums = {
					operatorNum: peratorNum,
				}
				this.$axios
					.post('/api/grade/getNewGradeByOperatorNum', OperatorNums)
					.then(function(res) {
						if(res.data.code == 200) {
							that.userlogo = res.data.data.logo;
							that.total_points = res.data.data.totalPoints?res.data.data.totalPoints.toFixed(2):res.data.data.totalPoints;
							that.gradea = res.data.data.grade;
							that.aquarter=that.aquarter?that.aquarter:res.data.data.quarter;
							that.ayears=that.ayears?that.ayears:res.data.data.year.toString();
							// that.grade=that.grade?that.grade:res.data.data.grade;
							that.grade=res.data.data.grade;
							console.log(1,res.data.data.totalPoints)
							if(res.data.data.totalPoints) {
								that.greadeDetail(res.data.data.gradeId);
							}else{
								that.selectScoreItem()
							}
						} else {
							that.$message.error(res.data.msg);
						}

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			//打分列表
			setabt() {
				if(this.ayears == '' || this.ayears == null) {
					this.$message.error('请选择年份！！！');
					return false;
				}
				if(this.aquarter == '') {
					this.$message.error('请选择季度！！！');
					return false;
				}
				this.selectGradeByOperatorNums(this.curId);
			},
			selectScoreItem() {
				let that = this;
				let myDate = new Date();
				let years = myDate.getFullYear(); //获取当前年
				let mon = myDate.getMonth() + 1; //获取当前月
				let aquarters = 1
				if(mon >= 1 && mon < 4) {
					aquarters = 1;
				} else if(mon >= 4 && mon < 7) {
					aquarters = 2;
				} else if(mon >= 7 && mon < 10) {
					aquarters = 3;
				} else if(mon >= 10 && mon < 12) {
					aquarters = 4;
				}
				this.ayear = this.ayears || '' + years;
				this.aquarte = this.aquarter || aquarters;

				let greade = {
					operatorNum: this.curId,
					year: this.ayear,
					quarter: this.aquarte
				}
				this.$axios
					.post('/api/scoreItem/selectScoreItemGrade', greade)
					.then(function(res) {
						if(res.data.code == 200) {
							that.selectScoreItemlist = res.data.data;
						} else {
							that.$message.error(res.data.msg)
						}
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});

			},

			//评分细则
			greadeDetail(index) {
				let that = this;
				this.gradeId = index;

				let greade = {
					gradeId: this.gradeId,
				}
				this.$axios
					.post('/api/greadeDetail/selectGradeDetailByGradeId', greade)
					.then(function(res) {
						that.selectScoreItemlist = res.data.data;
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});

			},

			onChange() {
				let that = this;
				let totalPoint = 0;
				for(var i = 0; i < that.selectScoreItemlist.length; i++) {
					if(that.selectScoreItemlist[i].itemScore != null) {
						if(that.selectScoreItemlist[i].itemScore >= 0) {
							totalPoint += Number(that.selectScoreItemlist[i].itemScore);
						} else {
							that.selectScoreItemlist[i].itemScore = 0;
						}
					}
				}
				if(totalPoint >= 80) {
					this.grade = 'A';
				} else if(totalPoint > 70 && totalPoint < 80) {
					this.grade = 'B';
				} else if(totalPoint >= 60 && totalPoint <= 70) {
					this.grade = 'C';
				} else if(totalPoint < 60) {
					this.grade = 'D';
				}
				this.totalPoints = totalPoint

			},

			//打分
			onInputChange() {
				let that = this;
				if(this.ayears == '' || this.ayears == null) {
					this.$message.error('请选择年份！！！');
					return false;
				}
				if(this.aquarter == '') {
					this.$message.error('请选择季度！！！');
					return false;
				}
				let cerat = {
					grade: this.grade,
					operatorNum: this.curId, // 运营商
					createGradeitemDtos: [],
					year: this.ayears,
					quarter: this.aquarter
				}
				for(var i = 0; i < that.selectScoreItemlist.length; i++) {
					if(that.selectScoreItemlist[i].itemScore < 0) {
						that.$message.error('打分项不能为负数');
						return false;
					}
					//console.log(that.selectScoreItemlist[i].scoreValue)
					if(that.selectScoreItemlist[i].itemScore == null) {
						that.$message.error('请添加打分项');
						return false;
					}
					if(that.selectScoreItemlist[i].itemScore > that.selectScoreItemlist[i].scoreValue) {
						that.$message.error('打分项不能超过当前分值');
						return false;
					}

					cerat.createGradeitemDtos.push({
						scoreItemId: that.selectScoreItemlist[i].scoreItemId,
						itemScore: that.selectScoreItemlist[i].itemScore,
					})
				}

				this.$axios
					.post('/api/grade/createGrade', cerat)
					.then(function(res) {
						if(res.data.code == 200) {
							that.$message({
								message: '打分成功',
								type: 'success'
							});
							window.setTimeout(() => {
								location.reload();
							}, 1000);
						} else {
							that.$message.error(res.data.msg)
						}

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			//新建工单
			workOrderAdd() {
				let that = this;

				if(this.workOrder.checkContent == undefined) {
					that.$message.error("请输入考核内容");
					return false;
				}
				if(this.workOrder.checkPopulation == undefined) {

					that.$message.error("请输入考核人数");
					return false;
				}
				if(this.workOrder.address == undefined) {
					that.$message.error("请输入考核地址");
					return false;
				}

				if(this.workOrder.pointNum == undefined) {
					that.$message.error("请输入考核考核点位数");
					return false;
				}

				if(this.workOrder.supervisor == undefined) {
					that.$message.error("请输入考核监督员");
					return false;
				}
				let workOrderdata = {
					checkContent: this.workOrder.checkContent,
					checkPopulation: this.workOrder.checkPopulation,
					address: this.workOrder.address,
					pointNum: this.workOrder.pointNum,
					supervisor: this.workOrder.supervisor,
				}
				this.$axios.defaults.withCredentials = true;
				this.$axios
					.post('/api/workOrder/workOrderAdd', workOrderdata)
					.then(function(res) {
						if(res.data.code == 200) {
							that.$message({
								message: '提交成功',
								type: 'success'
							});
							window.setTimeout(() => {
								location.reload();
							}, 1000);
						} else {
							that.$message.error(res.data.msg)
						}

					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			//我的工单
			selectWorkOrder() {
				let that = this;
				this.dialogworkVisible = true;
				let workOrderd = {
					page: this.WorkOrderpage,
					pageSize: this.workOrderpageSize,
				}
				this.$axios.defaults.withCredentials = true;
				this.$axios
					.post('/api/workOrder/selectWorkOrder', workOrderd)
					.then(function(res) {
						that.workOrdertotal = res.data.data.total;
						that.workOrlist = res.data.data.list;
					}).catch(function(error) { // 请求失败处理
						console.log("服务器错误" + error);
					});
			},
			setselWorkOrder(WorkOrderpage) {
				this.WorkOrderpage = WorkOrderpage;
				this.selectWorkOrder();
			},

			//问卷
			questi() {
				location.href = api_duck + 'login?phong=' + this.userphone + '&type=danche';
			},

		},

	}
</script>
<style type="text/css">
	
	input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{
        -webkit-appearance:textfield;
    }    
    input[type="number"]{
        -moz-appearance:textfield;
    }
</style>
<style scoped>
	.grid-content h2 {
		margin-bottom: 0px!important;
		margin-top: 0px!important;
		line-height: 58px;
	}
	
	/deep/ .el-button--primary {
		margin-bottom: 0px!important;
		margin-top: 0px!important;
	}
	
	.grid-cont .aimg {
		width: 54px;
		height: 56px;
		margin: 29px 0 39px 62px;
	}
	
	.grid-cont .aimg img {
		width: 100%;
		height: 100%;
	}
	
	.grid-cont .atitle {
		margin: 47px 60px;
		line-height: 0rem;
	}
	
	.grid-cont .atitle h3 {
		margin: 0;
		line-height: 30px;
	}
	
	.grid-cont .atitle span {
		margin: 0;
		line-height: 30px;
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 800;
		color: #999999;
	}
	
	.grid-cont {
		border-radius: 0px;
		min-height: 36px;
		min-width: 327px!important;
		position: relative;
		margin-bottom: 20px;
		padding: 0px!important;
		display: flex;
		line-height: 0px;
		flex-direction: row;
		/*这里可以不写，flex布局默认方向横向即row*/
		justify-content: center;
		align-items: center;
	}
	
	.clear {
		clear: both;
	}
	
	.grid-ent {
		border-radius: 0px;
		min-height: 36px;
		min-width: 327px!important;
		position: relative;
		margin-bottom: 20px;
		padding: 0px!important;
		display: flex;
	}
	
	.grid-ent .avatar {
		text-align: left;
	}
	
	.grid-ent .avatar {
		width: 104px;
		height: 104px;
		margin: 33px 75px;
	}
	
	.el-select {
		width: 120px;
	}
	
	.grid-ent .approval {
		margin: 27px 0;
	}
	
	.grid-ent .approval .total {
		display: flex;
		line-height: 55px;
	}
	
	.grid-ent .approval .point {
		display: flex;
		line-height: 0px;
		flex-direction: row;
		/*这里可以不写，flex布局默认方向横向即row*/
		justify-content: center;
		align-items: center;
	}
	
	.point .el-col-4 .el-select {
		width: auto !important;
	}
	
	.grid-ent .approval h2 {
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #999999;
		margin: 0;
	}
	
	.grid-ent .approval span {
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #666666;
		margin-right: 59px;
	}
	
	.grid-ent .approval h2 {
		font-size: 20px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #999999;
		margin: 0;
	}
	
	.el-tag {
		margin: 3px 0 0px 30px;
	}
	
	/deep/ input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}
	
	/deep/ input[type='number'] {
		-moz-appearance: textfield;
	}
	
	/deep/ .el-textarea.is-disabled .el-textarea__inner {
		background-color: #FFFFFF;
		border: 0px;
		color: #606266;
		cursor: not-allowed;
	}
	
	.lu_head {
		float: left;
		overflow: hidden;
		width: calc(100% - 120px);
	}
	
	.lu_list {
		font-size: 24px;
		padding: 10px 0;
		line-height: 26px;
		border-radius: 5px;
		margin: 5px 0 5px 20px;
		max-width: 116px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		float: left;
		color: #909399;
		cursor: pointer;
	}
	
	.lu_list img {
		width: 24px;
		height: 24px;
		margin-right: 10px;
		position: relative;
		top: 2px;
		filter: grayscale(90%);
	}
	
	.lu_list:hover {
		color: #333;
	}
	
	.lu_list:hover img {
		filter: grayscale(0%);
	}
	
	.lu_active {
		color: #333 !important;
	}
	
	.lu_active img {
		filter: grayscale(0%) !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/admin/Grade.vue